/**
 * Copyright (c) 2019-Present Syncari - All rights reserved.
 */
import cx from 'classnames';

import type { InputGroupProps } from '../../types';
import './InputGroup.less';

const InputGroup = ({ children, className }: InputGroupProps) => (
  <div className={cx('input-group', className)}>{children}</div>
);

InputGroup.displayName = 'InputGroup';

export default InputGroup;
